<template>
    <v-card>
        <v-card-text class="text-center px-0">
            <div class="font-weight-bold mb-2">{{location}}</div>
            <schnitt-feld :value="schnitt"
                          :class="[{'mobile': $vuetify.breakpoint.xsOnly},
                                    {'mobile': $vuetify.breakpoint.smAndUp}]">
            </schnitt-feld>
            <div>{{spiele}} Spiel<span v-if="spiele>1 || spiele===0">e</span></div>
        </v-card-text>
    </v-card>
</template>

<script>
    import SchnittFeld from "./components/schnittFeld";

    export default {
        components: {SchnittFeld},
        name: "spieler-performance-schnitt",
        props: ['location', 'schnitt', 'spiele'],
    }
</script>

<style scoped>
    .desktop {font-size: 32px}
    .mobile {font-size: 24px}
</style>